module.exports = __webpack_public_path__ + "img/CA.7047f5aa.png";